import { CLEAR_CATEGORIES } from './index';

export const clearCategoriesAction = (categories) => ({
    type: CLEAR_CATEGORIES,
    categories
});